<script>
import {defineComponent} from 'vue'
import api from "@/api/api"
import {formatIsoToCustom} from "@/common/formatToIso";
import {processObjectNullValues} from "@/common/processObjectNullValues";
import TicketLayouts from "@/components/Tickets/layouts/TicketLayouts.vue";

export default defineComponent({
  name: "TicketTypes",
  components: {TicketLayouts},
  data() {
    return {
      // pagination
      currentPage: 1,
      perPage: 15,
      perPageOptions: [
        {value: 10, text: '10 на странице'},
        {value: 15, text: '15 на странице'},
        {value: 25, text: '25 на странице'},
        {value: 50, text: '50 на странице'}
      ],
      meta: {
        current_page: 1,
        from: 0,
        last_page: 1,
        per_page: 15,
        to: 0,
        total: 0
      },
      links: {
        first: null,
        last: null,
        prev: null,
        next: null
      },
      //
      typeParams: {
        name: "",
        enabled: true,
      },
      ticketTypes: [],
      sidebarFields: [],
      isLoading: false,
      isSidebarLoading: false,
      selectedType: {},
      fields: [
        {key: 'id', label: '№',sortable: true},
        {key: 'date', label: 'Дата', sortable: true},
        {key: 'name', label: 'Название'},
        {key: 'enabled', label: 'Включено',},
        {key: 'username', label: 'Кем создан',},
        {key: "actions", label: "Действия"}
      ]
    }
  },
  methods: {
    async getTicketTypes(params = {page: this.currentPage, per_page: this.perPage}) {
      this.isLoading = true;
      try {
        const res = await api.tickets.getListTicketTypes(params)
        this.ticketTypes = res.data?.data.map((type) => processObjectNullValues({
          id: type.id,
          date: formatIsoToCustom(type.created_at),
          name: type.name,
          enabled: type.enabled ? 'Да' : "Нет",
          username: type.created_by?.username || type.created_by?.email,
        }));

        // Set pagination meta and links
        if (res.data?.meta) {
          this.meta = res.data.meta;
        }
        if (res.data?.links) {
          this.links = res.data.links;
        }

        this.isLoading = false;
      } catch (e) {
        console.log(e)
      } finally {
        this.isLoading = false;
      }
    },
    async createType() {
      if (this.typeParams.name === "") {
        this.$bvToast.toast('Введите название', {
          title: "Валидация",
          variant: "danger",
        })
        return false
      }
      try {
        const res = await api.tickets.createTicketType(this.typeParams)
        const newType = res.data?.data
        const formattedType = processObjectNullValues({
          id: newType.id,
          name: newType.name,
          date: formatIsoToCustom(newType.created_at),
          username: newType.created_by?.username || newType.created_by?.email,
          enabled: newType.enabled ? 'Да' : 'Нет',
          _original: newType
        })
        this.ticketTypes.push(formattedType)
        this.$bvModal.hide('create-type')
        this.typeParams.name = "";
      } catch (e) {
        console.log(e)
        this.$bvToast.toast(e.response.message || e.response.data.message || 'Произошла ошибка', {
          title: "Ошибка сервера",
          variant: "danger",
        })
      }
    },
    async openEditSidebar(item) {
      this.sidebarFields = [
        {
          key: 'name',
          label: 'Название',
          type: 'text',
          placeholder: 'Введите название',
          required: true
        },
        {
          key: 'enabled',
          label: 'Включено',
          type: 'checkbox',
          default: true
        }
      ]
      this.selectedType = {
        id: item.id,
        name: item.name,
        enabled: item.enabled
      }
      this.$root.$emit('bv::toggle::collapse', 'sidebar-right')
    },
    async handleSaveType(formData) {
      this.isSidebarLoading = true
      try {
        const res = await api.tickets.updateTicketType(this.selectedType?.id, {
          enabled: formData.enabled,
          name: formData.name
        })
        const updatedData = res.data?.data || formData
        const index = this.ticketTypes.findIndex(type => type.id === formData.id)
        if (index !== -1) {
          const oldItem = this.ticketTypes[index]
          this.$set(this.ticketTypes, index, processObjectNullValues({
            id: updatedData.id,
            date: oldItem.date,
            name: updatedData.name,
            enabled: updatedData.enabled ? 'Да' : 'Нет',
            username: oldItem.username,
            _original: updatedData
          }))
        }
        this.$bvToast.toast('Тип успешно обновлена', {
          title: "Успех",
          variant: "success",
        })
        this.$root.$emit('bv::toggle::collapse', 'sidebar-right')
        this.selectedType = null
      } catch (e) {
        console.log(e)
        this.$bvToast.toast(e.response?.message || e.response?.data?.message || 'Произошла ошибка', {
          title: "Ошибка сервера",
          variant: "danger",
        })
      } finally {
        this.isSidebarLoading = false;
      }
    },
    async deleteType(type) {
      try {
        if (type && type.id) {
          await api.tickets.deleteTicketType(type?.id)
        }
        this.ticketTypes = this.ticketTypes.filter(item => item.id !== type.id)
      } catch (e) {
        console.log('deleting type error: ', e)
        this.$bvToast.toast(e.response.message || e.response.data.message || 'Произошла ошибка', {
          title: "Ошибка сервера",
          variant: "danger",
        })
      }
    },
    onPageChange(page) {
      this.currentPage = page
      this.getTicketTypes({page: page, per_page: this.perPage})
      window.scrollTo({top: 0, behavior: 'smooth'})
    },
    changePerPage() {
      this.currentPage = 1
      this.getTicketTypes({page: 1, per_page: this.perPage})
    }
  },
  watch: {
    'meta.current_page': {
      handler(newPage) {
        if (newPage && this.currentPage !== newPage) {
          this.currentPage = newPage
        }
      }
    }
  },
  mounted() {
    this.getTicketTypes({page: this.currentPage, per_page: this.perPage})
  }
})
</script>

<template>
  <TicketLayouts title="Редактировать Типы"
                 :sidebar-fields="sidebarFields"
                 :sidebar-item="selectedType"
                 :sidebar-loading="isSidebarLoading"
                 @sidebar-save="handleSaveType"
  >
    <Breadcrumbs main="Tickets" title="Типы обращений"/>
    <div class="d-flex justify-content-end">
      <b-button v-b-modal.create-type variant="success">
        Создать
      </b-button>
    </div>
    <div class="container-fluid">
      <b-table
          responsive
          show-empty
          stacked="md"
          :items="ticketTypes"
          striped
          bordered
          :fields="fields"
      >
        <template #cell(actions)="{item}">
          <b-button
              class="mr-2"
              variant="primary"
              size="sm"
              @click="openEditSidebar(item)"
          >
            <i class="fas fa-edit"></i> Редактировать
          </b-button>
          <b-button
              variant="danger"
              size="sm"
              @click="deleteType(item)"
          >
            <i class="fas fa-trash"></i> Удалить
          </b-button>
        </template>
      </b-table>
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div class="text-muted">
          Показано с {{ meta.from }} по {{ meta.to }} из {{ meta.total }} записей
        </div>
        <div class="d-flex align-items-center gap-2">
          <b-form-select
              v-model="perPage"
              :options="perPageOptions"
              size="sm"
              @change="changePerPage"
              class="mr-2"
          ></b-form-select>
          <b-pagination
              v-model="currentPage"
              :total-rows="meta.total"
              :per-page="meta.per_page"
              @change="onPageChange"
              align="right"
              size="sm"
          ></b-pagination>
        </div>
      </div>
    </div>

    <b-modal id="create-type" title="Создать Тип" hide-footer>
      <b-form @submit.prevent="createType">
        <b-form-input v-model="typeParams.name" placeholder="Название"/>
        <div class="mt-3 d-flex spacing gap-1">
          <b-form-checkbox v-model="typeParams.enabled" :value="typeParams.enabled"></b-form-checkbox>
          <p>Включено</p>
        </div>
        <b-button class="mt-3 w-100" type="submit">Создать</b-button>
      </b-form>
    </b-modal>
  </TicketLayouts>
</template>

<style scoped lang="scss">

</style>